import { NavLink } from 'react-router-dom';

import { SidebarChildItemType } from 'types/sidebar';

type SidebarNavItemProps = {
  item: SidebarChildItemType;
};

function SidebarNavItem({ item }: SidebarNavItemProps) {
  return (
    <li className={'lnb_l1'}>
      <NavLink to={item.href} className={'lnb_a1'}>
        {item.name}
      </NavLink>
    </li>
  );
}

export default SidebarNavItem;
